import { QueryClient } from '@tanstack/react-query';

// Single app-wide cache. Pages opt in via useQuery; everything else is
// unaffected. The "always there" feel comes from showing cached data
// instantly while a background refetch keeps it fresh.
//
// apiFetch (api.js) is the underlying fetcher. On a 401 it already signs the
// user out and redirects to /login, so there is nothing useful to retry —
// the retry rule below bails out on auth failures to avoid hammering.
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,          // treat data as fresh for 30s (no refetch on quick re-navigations)
      gcTime: 5 * 60_000,         // keep unused cache around for 5 min
      refetchOnWindowFocus: true, // silent background refresh when you tab back in
      retry: (failureCount, error) => {
        // apiFetch throws Error('Request failed: 401') shapes; never retry auth errors.
        const msg = String(error?.message || '');
        if (msg.includes('401') || /unauthor/i.test(msg)) return false;
        return failureCount < 1;
      },
    },
  },
});
